const commonConfig = require('./common');

const WebsiteHostname = 'www.onestore.io'
const WebsiteOrigin = 'https://' + WebsiteHostname

const RESTAPIOrigin = 'https://api.onestore.io'
const ApiBasePath = '/v1'

const _exports = {
  env: 'prod',

  auth0ClientID: "8trClpRywSFBl6uV3rkdgq032ki29Aa9",

  JWTTokenStorageKey: 'onestore.jwt_token',

  auth0WebsiteAudience: "https://api.onestore.io/",

  restAPIURL: RESTAPIOrigin + ApiBasePath,

  CreateTokenPopupURL: WebsiteOrigin + '/#/app-login',
  LoginWebsitePopupURL: WebsiteOrigin + '/#/app-login',

  APIDomainName: "api.onestore.io",
  WWWDomainName: "www.onestore.io",
  WWWDomainName2: "onestore.io",
  CertificateArn: "arn:aws:acm:us-east-1:062399315300:certificate/42f78325-0bcc-4730-a470-17f53f9fc3a4",
  DomainNamesEnabled: true,

  WebsiteOrigin: WebsiteOrigin,
  StaticOrigin: WebsiteOrigin,

  max_api_calls: 1500,
  max_namespaces: 50,
  max_tokens: 50,
  max_userdata_item_size_bytes: 5 * 1024,
  max_userdata_items_count: 10000,
  default_page_size: 10,
  max_page_size: 20,
}

for (var k in commonConfig) _exports[k] = commonConfig[k]

module.exports = _exports


//////////////////
// WEBPACK FOOTER
// ../config/prod.js
// module id = mdz0
// module chunks = 1